import { Node } from "reactflow"
import { SupabaseConnector } from "../database/SupabaseConnector"
import { SetNodesState, UISheet } from "../types/UITypes"

export async function resizeFlowchartCondition(
  flowChartCondition: UISheet,
  setNodes: SetNodesState,
  supabaseConnector: SupabaseConnector
) {
  let updatedNode: Node | undefined

  setNodes((nodes) =>
    nodes.map((node) => {
      if (node.data.id !== flowChartCondition.id) {
        return node
      }

      updatedNode = {
        ...node,
        data: {
          ...node.data,
          width: flowChartCondition.width,
          height: flowChartCondition.height,
        },
        width: flowChartCondition.width,
        height: flowChartCondition.height,
      }

      return updatedNode
    })
  )

  if (updatedNode) {
    await supabaseConnector.updateNode(updatedNode)
  }
}
